import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Grid, Row, Col, Button } from "react-bootstrap";
import Card from "components/Card/Card.jsx";
// import SettingsModal from "components/Settings/SettingsModal.js"; // Supprimé pour éviter les conflits
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import Cookie from "js-cookie";

class Settings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSettingsModal: false,
            showSubscriptionModal: false,
            currentFirebaseUser: null,
            authChecked: false,
            subscriptionData: null,
            subscriptionLoading: false,
            subscriptionError: null
        };
    }

    componentDidMount() {
        // Écouter les changements d'authentification Firebase
        this.unsubscribe = firebase.auth().onAuthStateChanged((user) => {
            this.setState({ 
                currentFirebaseUser: user,
                authChecked: true 
            });
        });
    }

    componentWillUnmount() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }

    openSettings = () => {
        const { currentFirebaseUser } = this.state;
        const { user } = this.props;
        
        // Vérifier qu'un utilisateur est connecté avant d'ouvrir les paramètres
        if (!currentFirebaseUser && !user) {
            alert("Vous devez être connecté pour accéder aux paramètres. Veuillez vous reconnecter.");
            window.location.href = '/';
            return;
        }
        
        this.setState({ showSettingsModal: true });
    };

    closeSettings = () => {
        this.setState({ showSettingsModal: false });
    };

    openSubscriptionManager = async () => {
        alert("🚀 CLIC DÉTECTÉ - Bouton abonnement cliqué !");
        
        this.setState({ 
            showSubscriptionModal: true,
            subscriptionLoading: true,
            subscriptionError: null 
        }, () => {
        });
        
        await this.loadSubscriptionData();
    };

    closeSubscriptionManager = () => {
        this.setState({ showSubscriptionModal: false });
    };

    loadSubscriptionData = async () => {
        try {
            
            const testUserData = {
                email: "test@example.com",
                name: "Utilisateur Test",
                subscription: {
                    plan: "Premium",
                    active: true,
                    startDate: new Date('2024-01-01'),
                    endDate: new Date('2024-12-31'),
                    amount: 175000,
                    currency: 'FCFA'
                }
            };
            
            // Calculer le statut de l'abonnement
            let status = 'Inactif';
            let daysRemaining = 0;
            
            if (testUserData.subscription.endDate) {
                const endDate = testUserData.subscription.endDate;
                const now = new Date();
                const diffTime = endDate - now;
                daysRemaining = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                
                if (daysRemaining > 0) {
                    status = 'Actif';
                } else {
                    status = 'Expiré';
                }
            }
            
            
            this.setState({
                subscriptionData: {
                    email: testUserData.email,
                    name: testUserData.name,
                    plan: testUserData.subscription.plan,
                    status: status,
                    startDate: testUserData.subscription.startDate,
                    endDate: testUserData.subscription.endDate,
                    amount: testUserData.subscription.amount,
                    currency: testUserData.subscription.currency,
                    daysRemaining: daysRemaining,
                    active: testUserData.subscription.active
                },
                subscriptionLoading: false,
                subscriptionError: null
            });
            
            return; // Sortir pour tester avec des données simulées
            
            // ANCIEN CODE (commenté pour test)
            /*
            const db = firebase.firestore();
            
            // NOUVELLE MÉTHODE : Recherche exhaustive dans Firestore
            
            let userDoc = null;
            let foundMethod = null;
            
            // Méthode 1: Récupérer la session key du cookie
            const sessionKey = Cookie.get('session_key');
            
            if (sessionKey) {
                const sessionQuery = await db.collection('users')
                    .where('randomString', '==', sessionKey)
                    .limit(1)
                    .get();
                
                if (!sessionQuery.empty) {
                    userDoc = sessionQuery.docs[0];
                    foundMethod = "session_key";
                }
            }
            
            // Méthode 2: Essayer avec les données Redux/Firebase et localStorage
            if (!userDoc) {
                const { currentFirebaseUser } = this.state;
                const { user, profile } = this.props;
                
                // Essayer aussi de récupérer depuis localStorage
                const lastLoggedUser = localStorage.getItem('lastLoggedUser');
                let localUserData = null;
                if (lastLoggedUser) {
                    try {
                        localUserData = JSON.parse(lastLoggedUser);
                    } catch (e) {
                    }
                }
                
                const activeUserEmail = currentFirebaseUser?.email || user?.email || profile?.email || localUserData?.email;
                const activeUserId = currentFirebaseUser?.uid || user?.uid || localUserData?.uid;
                
                if (activeUserId) {
                    userDoc = await db.collection('users').doc(activeUserId).get();
                    if (userDoc.exists) {
                        foundMethod = "userId";
                    }
                }
                
                if (!userDoc?.exists && activeUserEmail) {
                    const emailQuery = await db.collection('users')
                        .where('email', '==', activeUserEmail)
                        .limit(1)
                        .get();
                    
                    if (!emailQuery.empty) {
                        userDoc = emailQuery.docs[0];
                        foundMethod = "email";
                    }
                }
            }
            
            // Méthode 3: Recherche par lastAccess récent
            if (!userDoc) {
                try {
                    const recentDate = new Date(Date.now() - 24 * 60 * 60 * 1000); // Dernières 24h
                    const recentQuery = await db.collection('users')
                        .where('lastAccess', '>=', recentDate)
                        .orderBy('lastAccess', 'desc')
                        .limit(5)
                        .get();
                    
                    if (!recentQuery.empty) {
                        // Prendre le plus récent
                        userDoc = recentQuery.docs[0];
                        foundMethod = "recent_access";
                    }
                } catch (error) {
                }
            }
            
            // Méthode 4: Fallback ultime - prendre le premier utilisateur actif
            if (!userDoc) {
                try {
                    const allUsersQuery = await db.collection('users')
                        .where('role', '==', 'user')
                        .limit(10)
                        .get();
                    
                    if (!allUsersQuery.empty) {
                        // Essayer de trouver un utilisateur avec un abonnement actif
                        for (const doc of allUsersQuery.docs) {
                            const data = doc.data();
                            if (data.subscription?.active) {
                                userDoc = doc;
                                foundMethod = "active_subscription";
                                break;
                            }
                        }
                        
                        // Si aucun avec abonnement actif, prendre le premier
                        if (!userDoc) {
                            userDoc = allUsersQuery.docs[0];
                            foundMethod = "fallback_first";
                        }
                    }
                } catch (error) {
                }
            }
            
            if (!userDoc?.exists) {
                throw new Error("Aucun utilisateur trouvé. Essayez de vous reconnecter.");
            }
            
            
            const userData = userDoc.data();
            const subscription = userData.subscription || {};
            
            // Calculer le statut de l'abonnement
            let status = 'Inactif';
            let daysRemaining = 0;
            
            if (subscription.endDate) {
                const endDate = subscription.endDate.toDate ? subscription.endDate.toDate() : new Date(subscription.endDate);
                const now = new Date();
                const diffTime = endDate - now;
                daysRemaining = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                
                if (daysRemaining > 0) {
                    status = 'Actif';
                } else {
                    status = 'Expiré';
                }
            }
            
            this.setState({
                subscriptionData: {
                    email: userData.email || activeUserEmail,
                    name: userData.name || 'Utilisateur',
                    plan: subscription.plan || 'Gratuit',
                    status: status,
                    startDate: subscription.startDate ? 
                        (subscription.startDate.toDate ? subscription.startDate.toDate() : new Date(subscription.startDate)) : null,
                    endDate: subscription.endDate ? 
                        (subscription.endDate.toDate ? subscription.endDate.toDate() : new Date(subscription.endDate)) : null,
                    amount: subscription.amount || 0,
                    currency: subscription.currency || 'FCFA',
                    daysRemaining: daysRemaining,
                    active: subscription.active || false
                },
                subscriptionLoading: false,
                subscriptionError: null
            });
            */
            
        } catch (error) {
            this.setState({
                subscriptionError: error.message,
                subscriptionLoading: false
            });
        }
    };

    render() {
        const { user, profile } = this.props;
        const { 
            showSettingsModal, 
            showSubscriptionModal, 
            currentFirebaseUser, 
            authChecked,
            subscriptionData,
            subscriptionLoading,
            subscriptionError
        } = this.state;

        // Debug: Afficher l'état de l'utilisateur

        // Récupérer les informations utilisateur de plusieurs sources
        const activeUserId = currentFirebaseUser?.uid || user?.uid;
        const activeUserEmail = currentFirebaseUser?.email || user?.email || profile?.email;
        const activeUserName = currentFirebaseUser?.displayName || user?.displayName || profile?.name;

        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                title="Paramètres"
                                content={
                                    <div style={{ padding: '20px' }}>
                                        <div style={{
                                            textAlign: 'center',
                                            marginBottom: '30px',
                                            padding: '40px 20px',
                                            background: 'linear-gradient(120deg, #34495e, #2c3e50)',
                                            borderRadius: '15px',
                                            boxShadow: '0 4px 15px rgba(52, 73, 94, 0.3)',
                                            backgroundImage: 'url("https://www.transparenttextures.com/patterns/brushed-alum.png")',
                                            backgroundBlendMode: 'soft-light'
                                        }}>
                                            <h2 style={{
                                                color: 'white',
                                                marginBottom: '15px',
                                                fontSize: '32px',
                                                fontWeight: '600',
                                                textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                            }}>
                                                <i className="fa fa-cog" style={{ marginRight: '15px' }}></i>
                                                Paramètres du Compte
                                            </h2>
                                            <p style={{
                                                color: 'rgba(255,255,255,0.9)',
                                                fontSize: '18px',
                                                margin: 0,
                                                fontWeight: '300'
                                            }}>
                                                Gérez votre profil, sécurité et préférences
                                            </p>
                                        </div>

                                        <Row>
                                            <Col md={4} sm={6} style={{ marginBottom: '20px' }}>
                                                <div style={{
                                                    backgroundColor: 'white',
                                                    borderRadius: '15px',
                                                    padding: '30px',
                                                    textAlign: 'center',
                                                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                                                    height: '200px',
                                                    borderTop: '4px solid #3498db'
                                                }}>
                                                    <div style={{ fontSize: '48px', color: '#3498db', marginBottom: '15px' }}>
                                                        <i className="fa fa-user"></i>
                                                    </div>
                                                    <h4>Profil</h4>
                                                    <p style={{ color: '#7f8c8d', marginBottom: '20px' }}>
                                                        Informations personnelles
                                                    </p>
                                                    <Button 
                                                        bsStyle="primary"
                                                        onClick={this.openSettings}
                                                    >
                                                        Modifier
                                                    </Button>
                                                </div>
                                            </Col>

                                            <Col md={4} sm={6} style={{ marginBottom: '20px' }}>
                                                <div style={{
                                                    backgroundColor: 'white',
                                                    borderRadius: '15px',
                                                    padding: '30px',
                                                    textAlign: 'center',
                                                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                                                    height: '200px',
                                                    borderTop: '4px solid #e74c3c'
                                                }}>
                                                    <div style={{ fontSize: '48px', color: '#e74c3c', marginBottom: '15px' }}>
                                                        <i className="fa fa-lock"></i>
                                                    </div>
                                                    <h4>Sécurité</h4>
                                                    <p style={{ color: '#7f8c8d', marginBottom: '20px' }}>
                                                        Mot de passe et sécurité
                                                    </p>
                                                    <Button 
                                                        bsStyle="danger"
                                                        onClick={this.openSettings}
                                                    >
                                                        Configurer
                                                    </Button>
                                                </div>
                                            </Col>

                                            <Col md={4} sm={6} style={{ marginBottom: '20px' }}>
                                                <div style={{
                                                    backgroundColor: 'white',
                                                    borderRadius: '15px',
                                                    padding: '30px',
                                                    textAlign: 'center',
                                                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                                                    height: '200px',
                                                    borderTop: '4px solid #f39c12'
                                                }}>
                                                    <div style={{ fontSize: '48px', color: '#f39c12', marginBottom: '15px' }}>
                                                        <i className="fa fa-star"></i>
                                                    </div>
                                                    <h4>Abonnement</h4>
                                                    <p style={{ color: '#7f8c8d', marginBottom: '20px' }}>
                                                        Gérer votre abonnement
                                                    </p>
                                                    <Button 
                                                        bsStyle="warning"
                                                        onClick={this.openSubscriptionManager}
                                                    >
                                                        Voir détails
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row style={{ marginTop: '30px' }}>
                                            <Col md={12}>
                                                <div style={{
                                                    backgroundColor: '#f8f9fa',
                                                    borderRadius: '10px',
                                                    padding: '20px',
                                                    textAlign: 'center'
                                                }}>
                                                    <h3 style={{ color: '#2c3e50', marginBottom: '20px' }}>
                                                        <i className="fa fa-question-circle" style={{ marginRight: '10px' }}></i>
                                                        Besoin d'aide ?
                                                    </h3>
                                                    <p style={{ color: '#7f8c8d', marginBottom: '20px' }}>
                                                        Consultez notre documentation ou contactez le support
                                                    </p>
                                                    <Button bsStyle="info" style={{ marginRight: '10px' }}>
                                                        <i className="fa fa-book"></i> Documentation
                                                    </Button>
                                                    <Button bsStyle="success">
                                                        <i className="fa fa-envelope"></i> Support
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>

                {/* SettingsModal supprimé temporairement pour éviter les conflits d'authentification */}
                {showSettingsModal && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1000,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <div style={{
                            backgroundColor: 'white',
                            borderRadius: '10px',
                            padding: '20px',
                            textAlign: 'center'
                        }}>
                            <h3>Paramètres temporairement indisponibles</h3>
                            <p>Cette fonctionnalité sera bientôt disponible.</p>
                            <button onClick={this.closeSettings} style={{
                                backgroundColor: '#3498db',
                                color: 'white',
                                border: 'none',
                                padding: '10px 20px',
                                borderRadius: '5px',
                                cursor: 'pointer'
                            }}>
                                Fermer
                            </button>
                        </div>
                    </div>
                )}

                {/* Nouveau modal d'abonnement */}
                {showSubscriptionModal && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1000,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '20px'
                    }}>
                        <div style={{
                            backgroundColor: 'white',
                            borderRadius: '15px',
                            width: '100%',
                            maxWidth: '600px',
                            maxHeight: '90vh',
                            overflow: 'hidden',
                            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)'
                        }}>
                            {/* Header */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '20px 24px',
                                borderBottom: '1px solid #e5e7eb',
                                background: 'linear-gradient(120deg, #f39c12, #e67e22)'
                            }}>
                                <h2 style={{
                                    margin: 0,
                                    fontSize: '24px',
                                    fontWeight: '600',
                                    color: 'white'
                                }}>
                                    <i className="fa fa-star" style={{ marginRight: '10px' }}></i>
                                    Gestion de l'Abonnement
                                </h2>
                                <button
                                    onClick={this.closeSubscriptionManager}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        fontSize: '24px',
                                        cursor: 'pointer',
                                        color: 'white',
                                        padding: '4px 8px',
                                        borderRadius: '4px'
                                    }}
                                >
                                    ×
                                </button>
                            </div>

                            {/* Content */}
                            <div style={{ padding: '24px' }}>
                                {subscriptionLoading && (
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '40px',
                                        color: '#6b7280'
                                    }}>
                                        <div style={{
                                            width: '40px',
                                            height: '40px',
                                            border: '4px solid #f3f3f3',
                                            borderTop: '4px solid #f39c12',
                                            borderRadius: '50%',
                                            animation: 'spin 1s linear infinite',
                                            marginBottom: '15px'
                                        }}></div>
                                        <p>Chargement des informations d'abonnement...</p>
                                    </div>
                                )}

                                {subscriptionError && (
                                    <div style={{
                                        backgroundColor: '#fef2f2',
                                        border: '1px solid #fecaca',
                                        borderRadius: '6px',
                                        padding: '16px',
                                        marginBottom: '20px',
                                        textAlign: 'center'
                                    }}>
                                        <p style={{ color: '#dc2626', margin: '0 0 12px 0' }}>
                                            {subscriptionError}
                                        </p>
                                        <button
                                            onClick={this.loadSubscriptionData}
                                            style={{
                                                backgroundColor: '#dc2626',
                                                color: 'white',
                                                border: 'none',
                                                padding: '8px 16px',
                                                borderRadius: '4px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            Réessayer
                                        </button>
                                    </div>
                                )}

                                {subscriptionData && !subscriptionLoading && !subscriptionError && (
                                    <div>
                                        {/* Informations utilisateur */}
                                        <div style={{
                                            backgroundColor: '#f8f9fa',
                                            borderRadius: '10px',
                                            padding: '20px',
                                            marginBottom: '20px'
                                        }}>
                                            <h3 style={{ color: '#2c3e50', marginBottom: '15px' }}>
                                                <i className="fa fa-user" style={{ marginRight: '10px' }}></i>
                                                Informations du compte
                                            </h3>
                                            <p><strong>Nom:</strong> {subscriptionData.name}</p>
                                            <p><strong>Email:</strong> {subscriptionData.email}</p>
                                        </div>

                                        {/* Statut de l'abonnement */}
                                        <div style={{
                                            backgroundColor: subscriptionData.status === 'Actif' ? '#d4edda' : '#f8d7da',
                                            borderRadius: '10px',
                                            padding: '20px',
                                            marginBottom: '20px',
                                            border: `2px solid ${subscriptionData.status === 'Actif' ? '#28a745' : '#dc3545'}`
                                        }}>
                                            <h3 style={{ 
                                                color: subscriptionData.status === 'Actif' ? '#155724' : '#721c24',
                                                marginBottom: '15px' 
                                            }}>
                                                <i className={`fa fa-${subscriptionData.status === 'Actif' ? 'check-circle' : 'times-circle'}`} 
                                                   style={{ marginRight: '10px' }}></i>
                                                Statut: {subscriptionData.status}
                                            </h3>
                                            <p><strong>Plan:</strong> {subscriptionData.plan}</p>
                                            {subscriptionData.endDate && (
                                                <p><strong>Date d'expiration:</strong> {subscriptionData.endDate.toLocaleDateString('fr-FR')}</p>
                                            )}
                                            {subscriptionData.status === 'Actif' && subscriptionData.daysRemaining > 0 && (
                                                <p><strong>Jours restants:</strong> {subscriptionData.daysRemaining}</p>
                                            )}
                                            {subscriptionData.amount > 0 && (
                                                <p><strong>Montant:</strong> {subscriptionData.amount} {subscriptionData.currency}</p>
                                            )}
                                        </div>

                                        {/* Actions */}
                                        <div style={{ textAlign: 'center' }}>
                                            {subscriptionData.status === 'Expiré' || subscriptionData.status === 'Inactif' ? (
                                                <button
                                                    onClick={() => window.location.href = '/abonnement'}
                                                    style={{
                                                        backgroundColor: '#28a745',
                                                        color: 'white',
                                                        border: 'none',
                                                        padding: '12px 24px',
                                                        borderRadius: '6px',
                                                        cursor: 'pointer',
                                                        fontSize: '16px',
                                                        fontWeight: '600'
                                                    }}
                                                >
                                                    <i className="fa fa-credit-card" style={{ marginRight: '8px' }}></i>
                                                    Renouveler l'abonnement
                                                </button>
                                            ) : (
                                                <button
                                                    onClick={() => window.location.href = '/abonnement'}
                                                    style={{
                                                        backgroundColor: '#f39c12',
                                                        color: 'white',
                                                        border: 'none',
                                                        padding: '12px 24px',
                                                        borderRadius: '6px',
                                                        cursor: 'pointer',
                                                        fontSize: '16px',
                                                        fontWeight: '600'
                                                    }}
                                                >
                                                    <i className="fa fa-cog" style={{ marginRight: '8px' }}></i>
                                                    Modifier l'abonnement
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

Settings.propTypes = {
    user: PropTypes.object,
    profile: PropTypes.object
};

const mapStateToProps = (state) => ({
    user: state.user.user,
    profile: state.user.profile
});

export default connect(mapStateToProps)(Settings);
